import Product from './product';
import Company from '../company/company';
import PMSColor from '../company/pmscolor';
import GenericModel from '../generic-model';

export default class ProductCompanyPMSColor extends GenericModel {
  product?: Product;
  company?: Company;
  pmsColor?: PMSColor;
}
